<template>
  <TransitionFade>
    <div v-if="open" id="parseResumeModal" class="fixed inset-0 bg-white z-max-2">
      <ParseResumeModalError v-if="store.resume.error" @retry="toggleOpen"/>
      <ParseResumeModalConfirm v-else-if="store.resume.confirm"/>
      <ParseResumeModalUploadingFile v-else-if="store.resume.uploading"/>
      <ParseResumeModalUnknownState v-else @toggleOpen="toggleOpen"/>
    </div>
  </TransitionFade>
</template>

<script setup>
import ParseResumeModalConfirm from "./ParseResumeModalConfirm.vue";
import ParseResumeModalError from "./ParseResumeModalError.vue";
import ParseResumeModalUnknownState from "./ParseResumeModalUnknownState.vue";
import ParseResumeModalUploadingFile from "./ParseResumeModalUploadingFile.vue";
import TransitionFade from "./TransitionFade.vue";
import {useParseResumeStore} from "../stores/ParseResumeStore.js";

const store = useParseResumeStore();

const emits = defineEmits(["update:open"]);
const props = defineProps({
  open: Boolean,
});

const toggleOpen = () => emits("update:open", !props.open);
</script>
